import { createAction } from '@reduxjs/toolkit';

export const requestViewNotifications = createAction('notification/viewNotifications');
export const requestAcknowledgeNotification = createAction('notification/acknowledge');
export const requestAcknowledgeNotificationsForChat = createAction('notification/acknowledgeForChat');
